import { useState, useEffect } from 'react';
import { getGallery } from '../api/api';
import { FaSearchPlus, FaTimes } from 'react-icons/fa';

const placeholders = Array.from({ length: 9 }, (_, i) => ({
  id: i + 1,
  imageUrl: `https://picsum.photos/seed/sbs${i + 1}/400/300`,
  caption: `Institute Photo ${i + 1}`,
}));

export default function Gallery() {
  const [images, setImages] = useState(placeholders);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    getGallery()
      .then(r => { if (r.data.length) setImages(r.data); })
      .catch(() => {});
  }, []);

  return (
    <div className="page">
      <div className="page-title">
        <h2>Our <span>Gallery</span></h2>
        <p>Glimpses of life at SBS Institute</p>
        <div className="gold-line" />
      </div>

      <div className="gallery-grid" style={{ marginTop: '2rem' }}>
        {images.map(img => (
          <div className="gallery-item" key={img.id} onClick={() => setLightbox(img)}>
            <img
              src={img.imageUrl?.startsWith('http') ? img.imageUrl : `https://sbs-coaching-backend-production.up.railway.app${img.imageUrl}`}
              alt={img.caption || 'Gallery'}
              loading="lazy"
            />
            <div className="gallery-overlay"><FaSearchPlus size={24} /></div>
          </div>
        ))}
      </div>

      {lightbox && (
        <div className="lightbox" onClick={() => setLightbox(null)}>
          <button className="lightbox-close" onClick={() => setLightbox(null)}><FaTimes size={24} /></button>
          <img
            src={lightbox.imageUrl?.startsWith('http') ? lightbox.imageUrl : `https://sbs-coaching-backend-production.up.railway.app${lightbox.imageUrl}`}
            alt={lightbox.caption || 'Preview'}
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
